module.exports = __webpack_public_path__ + "img/gift-box.f1109a2f.png";